// Point d'entrée : mount React + AppProviders.
// FOUC script dans index.html a déjà appliqué la classe .dark avant ce mount.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppProviders } from "@/app/AppProviders";
import "@/styles/globals.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
